module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NZ-9c214cfbcbea46f72c436e585929a22d.png";